module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--6--a-938b84fa.png";